<template>
	<div id="hotcontent">
		<div class="hotcontent-banner"></div>
		<div class="container">
			<div class="hot-content">
				<h2 style="padding: 40px 0;color: #333;">{{list.title}}</h2>
				<div class="news-nav border-top border-bottom">
					<span>作者：{{list.writer}}</span><span style="margin-left: 30px;">{{list.create_time}}</span>
				</div>
				<div class="news-nr" v-html="list.article"></div>
				<div class="border-bottom"></div>
				<share :config="config"></share>
				<router-link :to="'/hotcontent/'+before.id" class="page-article" v-if="after.title">上一篇：{{after.title}}</router-link>
				<router-link :to="'/hotcontent/'+after.id" class="page-article" v-if="before.title">下一篇：{{before.title}}</router-link>
			</div>
			<div class="hot-recommend">
				<div class="news-list">
					<h3 class="title">推荐新闻<router-link to="/hot">查看更多>></router-link></h3>
					<ul class="list">
						<li v-for="(item,i) in newsList">
							<router-link :to="'/hotcontent/'+item.id">
								<span class="number" :class="i<3?'red':'yellow'">{{i+1}}</span>
								<span class="item-title">{{item.title}}</span>
								<span class="views">{{item.hot}}<i class="icon" v-show="i<3"></i></span>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="video-list">
					<h3 class="title">推荐专访<router-link to="/video">查看更多>></router-link></h3>
					<ul class="list">
						<li v-for="(item,i) in videoList.slice(0,5)">
							<router-link :to="'/videocontent/'+item.id">
								<span class="number" :class="i<3?'red':'yellow'">{{i+1}}</span>
								<div class="cover">
									<img :src="item.picture" />
								</div>
								<div class="desc">{{item.title}}</div>
								<span class="views">{{item.hot}}<i class="icon" v-show="i<3"></i></span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				newsList:[],
				videoList:[],
				before:{
					title:'',
					id:''
				},
				after:{
					title:'',
					id:''
				}
			}

		},
		methods: {
			requestData(id) {
				var api = 'http://api.yopoo.cn/api/v1/minutenew?id='+id;
				this.$http.get(api).then((response) => {
						this.list = response.body.data
						this.before = response.body.front || {}
						this.after = response.body.after || {}
					},
					err => {
						console.log(err)
					}
				)
			},
			getNewsList() {
				this.$http.get('http://api.yopoo.cn/api/v1/visit?page=1&count=10&column=2').then((res) => {
					this.list = res.body.data
					this.pageArr = res.body.pagination //返回分页数组
					this.totalRow = res.body.pagination.total
				}, (err) => {
					console.log(err)
				})
			},
		},
		metaInfo() {
			return {
				title: this.list.title || '',
				meta: [{
					name: 'keywords',
					content: this.list.keywords || ''
				},
					{
						name: 'description',
						content: this.list.description || ''
					}
				]
			}
		},
		watch: {
			'$route' (to, from) { //监听路由是否变化
				if(this.$route.params.id){//判断id是否有值
					var id=this.$route.params.id;
					this.requestData(id);
				}
			}
		},
		created() {
			var id=this.$route.params.id;
			this.requestData(id);
			this.$http.get('http://api.yopoo.cn/api/v1/recommend?id=2').then((res) => {
				this.newsList = res.body.data || []
			}, (err) => {
				console.log(err)
			})
			this.$http.get('http://api.yopoo.cn/api/v1/recommend?id=1').then((res) => {
				this.videoList = res.body.data || []
			}, (err) => {
				console.log(err)
			})
		},
		updated() {
		}
	}
</script>
<style lang="less" rel="stylesheet">
	#hotcontent{
		margin-bottom: 40px;
		.hotcontent-banner{
			background: url('../assets/images/zhuanfang_banner.jpg') no-repeat center center;
			background-size: 100% 100%;
			height: 430px;
		}
		.container{
			display: flex;
			margin-bottom: 30px;
			.hot-content{
				 width: 800px;
				img{
					width: 100% !important;
				}
			 }
			.hot-recommend{
				margin-left: 30px;
				margin-top: 112px;
				.title{
					font-size: 20px;
					color: #333;
					position: relative;
					padding-left: 10px;
					height: 20px;
					line-height: 20px;
					a{
						font-size: 14px;
						color: #333;
						float: right;
						font-weight: normal;
					}
					&:after{
						content: "";
						position: absolute;
						top: 0;
						left: 0;
						display: inline-block;
						width: 4px;
						height: 20px;
						background: #FF0000;
					}
				}
				.number{
					display: inline-block;
					width: 20px;
					height: 20px;
					line-height: 20px;
					text-align: center;
					font-size: 14px;
					color: #fff;
					&.red{
						background: #ff0000;
					}
					&.yellow{
						background: #C8B9A6;
					}
				}
				i{
					display: inline-block;
					width: 12px;
					height: 12px;
					background: url("../assets/images/fire.png") no-repeat center center;
					background-size: auto 100%;
					vertical-align: baseline;
				}
				.news-list{
					width: 340px;
					background: #f8f8f8;
					padding: 20px;
					box-sizing: border-box;
					.list{
						li{
							height: 40px;
							border-bottom: 1px solid #E4E4E4;
							line-height: 40px;
							color: #333;
							font-size: 14px;
							&:hover{
								a{
									background: #f8f8f8;
									.item-title{
										color: #7E0007;
									}
								}

							}
							.item-title{
								height: 40px;
								line-height: 40px;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								width: 200px;
								display: inline-block;
								vertical-align: middle;
							}
							a{
								display: block;
							}
							.views{
								float: right;
								color: #666;
								width:50px;
								display: inline-block;
							}
						}
					}
				}
				.video-list{
					width: 340px;
					padding: 20px;
					background: #f8f8f8;
					box-sizing: border-box;
					margin-top: 40px;
					.list{
						li{
							&:hover{
								a{
									background: #f8f8f8;
									.desc{
										color: #7E0007;
									}
								}

							}
							a{
								display: flex;
								padding: 10px 0;
								border-bottom: 1px solid #E4E4E4;
								line-height: 40px;
								color: #333;
								font-size: 14px;
								position: relative;
								.cover{
									width: 114px;
									height: 86px;
									background: #fff;
									overflow: hidden;
									margin-left: 10px;
									display: flex;
									justify-content: center;
									img{
										height: 100%;
									}
								}
								.desc{
									margin-left: 10px;
									flex: 1;
									overflow: hidden;
									text-overflow:ellipsis;
									display: -webkit-box;
									-webkit-line-clamp: 2;
									-webkit-box-orient: vertical;
									line-height: 26px;
									height: 52px;
								}
								.views{
									position: absolute;
									right: 0;
									bottom: 0;
									width: 60px;
									display: inline-block;
								}
							}

						}
					}

				}
			}
		}
		.page-article{
			width: 1200px;
			display: block;
			margin: 0 auto;
			cursor: pointer;
			height: 40px;
			line-height: 40px;
			font-size: 16px;
			&:hover{
				color: #ff0000;
			}
		}
	}
	video{
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/HotContent.vue